import { State, Action, StateContext, Selector } from '@ngxs/store';
import { Injectable } from '@angular/core';
import { Menu } from 'src/app/models/menu.model';
import { MenuService } from 'src/app/services/apis/menu.service';
import {
  LoadMenu,
  LoadMenuSuccess,
  LoadMenuFail,
} from '../actions/menu.actions';
import { tap, catchError } from 'rxjs/operators';
import { of } from 'rxjs';

export interface MenuStateModel {
  menu: Menu[];
  error: string | null;
  loaded: boolean;
}

@State<MenuStateModel>({
  name: 'menu',
  defaults: {
    menu: [],
    error: null,
    loaded: false,
  },
})
@Injectable()
export class MenuState {
  constructor(private menuService: MenuService) {}

  @Selector()
  static menu(state: MenuStateModel): Menu[] {
    return state.menu;
  }

  @Selector()
  static menuLoaded(state: MenuStateModel): boolean {
    return state.loaded;
  }

  @Action(LoadMenu)
  loadMenu(ctx: StateContext<MenuStateModel>, action:LoadMenu) {
    return this.menuService.loadMenu(action.langIso).pipe(
      tap((menu) => {
        ctx.dispatch(new LoadMenuSuccess(menu));
      }),
      catchError((error) => {
        ctx.dispatch(new LoadMenuFail(error));
        return of(error);
      })
    );
  }

  @Action(LoadMenuSuccess)
  loadMenuSuccess(ctx: StateContext<MenuStateModel>, action: LoadMenuSuccess) {
    const state = ctx.getState();
    ctx.setState({
      ...state,
      menu: action.menu,
      error: null,
      loaded: true,
    });
  }

  @Action(LoadMenuFail)
  loadMenuFail(ctx: StateContext<MenuStateModel>, action: LoadMenuFail) {
    const state = ctx.getState();
    ctx.setState({
      ...state,
      error: action.error,
      loaded: false,
    });
  }
}
